import React from "react";
import { Row, Col, Button, Progress } from "antd";
import "whatwg-fetch";
import TwelveStatements from "../../components/MultipleChoice/TwelveStatements";
import {
  questionsDK_Twelvesections,
  questionsEN_Twelvesections
} from "./questions";

const intl = {
  name: {
    en: "FULL NAME",
    dk: "FULDE NAVN"
  },
  buttonSubmit: {
    en: "SUBMIT EVALUATION",
    dk: "INDSEND EVALUERING"
  },
  buttonSubmitPeer: {
    en: "COMPLETE EVALUATION",
    dk: "GENNEMFØR EVALUERING"
  },
  terms: {
    en: "By completing the survey you agree to Terms of Use and Privacy Policy",
    dk:
      "Ved at gennemfører spørgeskemaet accepterer du vores Terms of Use og Privacy Policy"
  },
  errorMessage: {
    en: "Something went wrong, please try again",
    dk: "Noget gik galt, prøv venligst igen"
  },
  explainer1: {
    en: "extremely uncharacteristic",
    dk: "ekstremt ukarakteristisk"
  },
  explainer6: {
    en: "extremely characteristic",
    dk: "ekstremt karakteristisk"
  },
  next: {
    en: "Next question",
    dk: "Næste spørgsmål"
  }
};

class TwelveStatementEvaluationQuestions extends React.Component {
  constructor() {
    super();
    this.state = {
      current: 0,
      scriptState: 1
    };
  }

  render() {
    const headline =
      this.props.lange === "dk"
        ? "Tag hvert nummer efter tur. Af de fem udsagn skal du vælge den, der er passer bedst på dig, og give den et højt score (mellem 7 og 10). Tag derefter det udsagn, der passer mindst på dig, og giv den et lavt score (mellem 0 og 3). Arranger derefter de andre tre udsagn imellem de to score du har givet, og giv dem hver et score der rangerer dem mellem dit laveste og højeste score."
        : "Take each number in turn. From the five statements pick out the one which is the most true for you and give it a high mark (between 7 and 10). Then take the descriptions that is least true for you and give it a low mark (between 0 and 3). Then arrange the other three statements between, giving each a mark that ranks them between you lowest and highest.";

    const choices = [
      {
        value: 1,
        title: "1",
        blocked: false
      },
      {
        value: 2,
        title: "2",
        blocked: false
      },
      {
        value: 3,
        title: "3",
        blocked: false
      },
      {
        value: 4,
        title: "4",
        blocked: false
      },
      {
        value: 5,
        title: "5",
        blocked: false
      },
      {
        value: 6,
        title: "6",
        blocked: false
      },
      {
        value: 7,
        title: "7",
        blocked: false
      },
      {
        value: 8,
        title: "8",
        blocked: false
      },
      {
        value: 9,
        title: "9",
        blocked: false
      },
      {
        value: 10,
        title: "10",
        blocked: false
      }
    ];

    const questionsLNG =
      this.props.language === "en"
        ? questionsEN_Twelvesections
        : questionsDK_Twelvesections;
    const questions = this.props.questions;

    return (
      <Row className="survey_content_container">
        <Col
          md={{ span: 16, offset: 4 }}
          xs={24}
          style={{ position: "absolute", top: "-190px" }}
        >
          {headline}

          <Progress
            percent={parseInt(
              (this.state.current / Object.keys(questionsLNG).length) * 100,
              10
            )}
            strokeWidth="20px"
          />
        </Col>
        <Col md={{ span: 16, offset: 4 }} xs={24}>
          <Row gutter={16}>
            <form
              onSubmit={e => {
                e.preventDefault();
                if (this.props.isPeerResponse) {
                  this.props.completeEvaluation(this.input.value);
                }
                this.props.completeEvaluation();
              }}
            >
              {this.props.isPeerResponse && (
                <Col key="name" md={24} style={{ marginBottom: "20px" }}>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    size="large"
                    ref={input => (this.input = input)}
                    placeholder={intl.name[this.props.language]}
                    // onChange={(e) => this.props.updateEvaluation({ scriptscriptStep++ })}
                    style={{
                      textAlign: "center",
                      color: "#1abc9c",
                      fontSize: "16px",
                      width: "100%",
                      border: "none",
                      padding: "10px",
                      borderRadius: "5px",
                      outline: "none"
                    }}
                    required
                  />
                </Col>
              )}

              {Object.keys(questionsLNG).map((key, index) => (
                <Col
                  key={key}
                  md={24}
                  className={`${index === this.state.current &&
                    "evalution_question_current"}
                    evalution_question_wrapper`}
                  // style={{ paddingTop: "5px" }}
                >
                  <TwelveStatements
                    key={key}
                    language={this.props.language}
                    questions={questionsLNG[key]}
                    questionValues={questions}
                    choices={choices}
                    changeCurrent={() => {
                      this.setState({ current: this.state.current + 1 });
                    }}
                    onChange={this.props.updateEvaluationQuestion}
                  />
                  <div
                    style={{
                      color: "#c0c0c0",
                      position: "absolute",
                      right: "20px",

                      top: "10px"
                    }}
                  >
                    {index + 1}/{Object.keys(questionsLNG).length}
                  </div>
                  <div
                    style={{
                      color: "#c0c0c0",
                      position: "absolute",
                      width: "100%",
                      bottom: "5px"
                    }}
                  />
                </Col>
              ))}
              {this.state.current < Object.keys(questionsLNG).length ? null : (
                <Col
                  md={{ span: 16, offset: 4 }}
                  xs={24}
                  style={{ marginTop: "10px" }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{ padding: "0 30px" }}
                    loading={this.props.submitting}
                  >
                    {this.props.isPeerResponse
                      ? intl.buttonSubmitPeer[this.props.language]
                      : intl.buttonSubmit[this.props.language]}
                  </Button>

                  <div>{intl.terms[this.props.language]}</div>
                  {this.props.error && (
                    <div style={{ color: "red" }}>
                      {intl.errorMessage[this.props.language]}
                    </div>
                  )}
                </Col>
              )}
            </form>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default TwelveStatementEvaluationQuestions;



// WEBPACK FOOTER //
// ./src/pages/Evaluation/TwelveStatementEvaluation.js